import React from "react";
import styles from "./AssistantVideoMessage.module.css";
import {ChatHistoryDTO, WidgetAppearanceLocaleVariantUi} from "../../../../../../../../api/generated";
import {MessageTime} from "../../messageTime/MessageTime";
import {TextInMarkdown} from "../../../../../../../elements/textInMarkdown/TextInMarkdown";

interface AssistantTextMessageProps {
    chatHistory: ChatHistoryDTO
    widgetAppearanceSettings: WidgetAppearanceLocaleVariantUi
}

export const AssistantVideoMessage: React.FC<AssistantTextMessageProps> = ({
                                                                               chatHistory,
                                                                               widgetAppearanceSettings
                                                                           }) => {
    const convertToEmbedURL = (url: string) => {
        if (url.startsWith("https://youtu.be/")) {
            const videoID = url.split("youtu.be/")[1];
            return `https://www.youtube.com/embed/${videoID}`;
        }
        if (url.startsWith("https://www.youtube.com/watch?v=")) {
            const videoID = url.split("www.youtube.com/watch?v=")[1];
            return `https://www.youtube.com/embed/${videoID}`;
        }
        return url;
    }

    return <div key={chatHistory.id} className={styles.wrapper}>
        <div className={styles.videoWrapper}>
            <iframe
                src={convertToEmbedURL(chatHistory.videoUrl!)}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        </div>
        <div className={styles.textWrapper}>
            <MessageTime timestamp={chatHistory.timestamp}/>
            <span className={styles.messageContent} style={{backgroundColor: widgetAppearanceSettings.brandColour}}>
                <TextInMarkdown text={chatHistory.message}/>
            </span>
        </div>
    </div>
}
